import { isDefaulter } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Button, Drawer, Notice } from "../design";
import "./reportDrawer.css";

const TenantProfileInsuranceModal = ({
  user,
  propertiesData,
  setShowPropertiesPopup,
  onClose,
  isOpen,
}) => {
  const { _t } = useTranslator();
  const experianData =
    user?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.["s:Body"]
      ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

  const isInsurancePreApproved = !isDefaulter(experianData);
  const hasProperties = (propertiesData?.length ?? 0) > 0;

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      title={_t("insurableCTAHeader")}
      closeLabel={_t("close")}
    >
      {isInsurancePreApproved ? (
        <Notice tone="success" title={_t("insurancePreApproved")}>
          {_t(
            "thisTenantMeetsTheInitialCriteriaForInsuranceFinalApprovalWillDependOnTheRentalPriceAndTheTenantsTheyWillLiveWith"
          )}
          <div className="insurance-drawer__action">
            <span data-tooltip-id="request-insurance-tooltip">
              <Button
                size="sm"
                disabled={!hasProperties}
                onClick={() => setShowPropertiesPopup(true)}
              >
                {_t("requestInsurance")}
              </Button>
            </span>
          </div>
          {!hasProperties && (
            <ReactTooltip
              id="request-insurance-tooltip"
              noArrow
              className="react-tooltip-styling details-skor-tooltip"
              render={() => (
                <p>{_t("youNeedToLinkThisTenantToAPropertyToEnableThis")}</p>
              )}
            />
          )}
        </Notice>
      ) : (
        <Notice tone="danger" title={_t("insuranceNotAvailable")}>
          {_t(
            "thisTEnantIsNotEligibleForTheDefaultInsuranceOrWouldNeedAManualReview"
          )}
        </Notice>
      )}
    </Drawer>
  );
};

export default TenantProfileInsuranceModal;
